export default {
	// ja-JP.js
	security: {
		securityBind: "セキュリティ連携",
		securitySettings: "セキュリティ設定",
		level: "中",
		confirm: "確認",
		submitting: "送信中...",
		add: "追加",
		change: "変更",
		success: "更新に成功しました",
		select: "選択",

		birthday: "連絡先の誕生日",
		birthdayDesc: "連絡を取りやすくするために誕生日を登録します。個人情報は保護されます。",
		month: "月",
		day: "日",
		year: "年",
		birthdayRequired: "誕生日は必須です。",
		invalidBirthday: "無効な誕生日です。",
		invalidMonth: "無効な月です。",
		invalidDay: "無効な日です。",
		invalidYear: "無効な年です。",
		updateBirthdayFail: "誕生日の更新に失敗しました",
		birthdayVerify: "誕生日連携の認証",
		birthdayVerifyDesc: "アカウントのセキュリティ向上のために誕生日を登録してください。",

		email: "連絡先メール",
		emailDesc: "アカウント保護のためのメールです。登録できるのは本人のみです。",
		emailRequired: "メールアドレスは必須です。",
		emailInvalid: "メールアドレスが正しくありません。",
		updateEmailFail: "メールアドレスの更新に失敗しました",
		emailVerify: "メール連携の認証",
		emailVerifyDesc: "アカウントのセキュリティ向上のためにメールアドレスを認証してください。",

		phone: "電話番号",
		bindPhone: "電話番号を登録",
		phoneDesc: "アカウント保護のための電話番号です。登録できるのは本人のみです。",
		phoneRequired: "電話番号は必須です。",
		phoneUsed: "別の電話番号を使用してください。",
		updatePhoneFail: "電話番号の更新に失敗しました",
		noCode: "コードが届きませんか？",
		smsHelp: "何度試しても認証コードが届かない場合。",
		smsTips1: "1. 入力した携帯番号が正しいか確認してください。",
		smsTips2: "2. 携帯番号が古くなっていないか確認してください。",
		smsTips3: "3. SMS受信箱にメッセージがあるか確認してください。",
		smsTips4: "4. メッセージの到着が数分遅れる場合があります。",
		phoneVerify: "電話番号連携の認証",
		phoneVerifyDesc: "アカウントのセキュリティ向上のために電話番号を認証してください。",

		setPassword: "パスワード設定",
		passwordDesc: "サインイン用パスワードを設定してください。",
		clickSelectBirthday: "クリックして誕生日を選択",
		selectBirthday: "誕生日を選択",
		confirm: "確定",
		cancel: "キャンセル",
		withdrawPassword: "出金パスワード",
		withdrawpasswordDesc: "出金用パスワードを設定します。",
		set: "設定",
	},

	contactPhone: {
		title: "電話番号を変更",
		titleMobile: "変更",
		description: "連絡用の電話番号を追加してください。個人情報は保護されます。",
		label: "連絡先電話番号",
		confirm: "確認",
		submitting: "送信中...",
		required: "電話番号は必須です",
		invalid: "電話番号が無効です",
		success: "電話番号を更新しました！",
		updateFailed: "更新に失敗しました",
		tryAgain: "更新に失敗しました。後ほど再度お試しください",
		verifyTitleMobile: "電話番号認証",
		titleMobile: "電話番号連携",
		changeTitleMobile: "電話番号変更",
		securityTip: "アカウントセキュリティのための電話番号です。ご本人様のみ連携できます。",
		placeholder: "電話番号",
		noCodeReceived: "コードが届かない場合は？",
		codeDescription: "以下のアドレスに送信された6桁の認証コードを入力してください：",
		resendIn: "{countdown} 秒後に再送",
		resend: "再送する",
		submitting: "送信中...",
		confirm: "確認",
		invalidCode: "有効な6桁のコードを入力してください",
		required: "電話番号を入力してください",
		invalid: "有効な電話番号を入力してください",
		success: "更新に成功しました",
		updateFailed: "更新に失敗しました",
		tryAgain: "しばらく経ってからもう一度お試しください"
	},

	contactEmail: {
		title: "メールアドレスを変更",
		titleMobile: "変更",
		description: "連絡用のメールアドレスを追加してください。個人情報は保護されます。",
		label: "連絡先メールアドレス",
		placeholder: "メールアドレス",
		confirm: "確認",
		submitting: "送信中...",
		required: "メールアドレスを入力してください",
		invalid: "正しいメールアドレスを入力してください",
		success: "メールアドレスを更新しました！",
		updateFailed: "更新に失敗しました",
		tryAgain: "更新に失敗しました。後ほど再度お試しください",
		verifyTitleMobile: "メール認証",
		titleMobile: "メールアドレス連携",
		changeTitleMobile: "メールアドレス変更",
		securityTip: "アカウントセキュリティのためのメールアドレスです。ご本人様のみ連携できます。",
		noCodeReceived: "コードが届かない場合は？",
		codeDescription: "以下のアドレスに送信された6桁の認証コードを入力してください：",
		resendIn: "{countdown} 秒後に再送",
		resend: "再送する",
		submitting: "送信中...",
		confirm: "確認",
		invalidCode: "有効な6桁のコードを入力してください",
		required: "メールアドレスを入力してください",
		invalid: "有効なメールアドレスを入力してください",
		success: "更新に成功しました",
		updateFailed: "更新に失敗しました",
		tryAgain: "しばらく経ってからもう一度お試しください"
	},

	accountInfo: {
		profileInfo: "プロフィール情報",
		contactInfo: "連絡先情報",
		privacy: "プライバシー",
		contactEmail: "連絡先メール",
		contactPhone: "連絡先電話番号",
		addEmailDesc: "連絡用のメールアドレスを追加してください。個人情報は保護されます。",
		addPhoneDesc: "連絡用の電話番号を追加してください。個人情報は保護されます。",
		hideUsername: "公開リストからユーザー名を非表示にする",
		add: "追加",
		change: "変更",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "プレイヤー",
		copied: "コピーしました！",
		hideSuccess: "ユーザー名を非表示にしました",
		showSuccess: "ユーザー名を表示しました",
		operationFailed: "操作に失敗しました",
		editProfile: "プロフィール編集",
		  contactInfo: "連絡先情報",
		  contactEmail: "連絡先メールアドレス",
		  emailTip: "よりスムーズな連絡のためにメールアドレスを追加してください。個人情報は保護されます。",
		  change: "変更",
		  addEmail: "メールアドレス追加",
		  contactPhone: "連絡先電話番号",
		  phoneTip: "安全なアカウント認証のために電話番号を追加してください。",
		  addPhone: "電話番号追加",
		  birthdayBind: "生年月日連携認証",
		  birthdayTip: "アカウントの安全性を高めるために生年月日を連携してください。",
		  addBirthday: "生年月日追加",
		  personalInfo: "個人情報",
		  personalTip: "本人確認を行って、より多くのサービスを利用しましょう。データは安全に保護されます。",
		  verifyNow: "今すぐ認証",
		  hideUsernameTip: "有効にすると、他のユーザーは公開リストであなたのユーザー名を表示できなくなります。",
	},

	kyc: {
		title: "本人確認",
		verifyIdentity: "本人確認を行う",
		completeDesc: "本人確認を完了して、アカウントを安全に保ち、すべての機能を利用できるようにしましょう。",
		failed: "確認に失敗しました。もう一度お試しください。",
		reVerify: "再確認",
		checkYouOut: "本人確認を始めましょう",
		prepareDoc: "書類を準備してください",
		prepareDocDesc: "有効な身分証明書をご用意ください。",
		useSmartphone: "スマートフォンを使用",
		useSmartphoneDesc: "確認を完了するにはスマートフォンが必要です。",
		scanQr: "QRコードをスキャン",
		scanQrDesc: "スマートフォンでQRコードをスキャンして、モバイルで続行してください。",
		noSmartphone: "スマートフォンがありませんか？",
		completeOnMobile: "モバイルで完了する"
	},

	verify: {
		title: "認証",
		personalVerification: "個人認証",
		weak: "低",
		level1: "レベル1",
		personalInfo: "個人情報",
		personalInfoDesc: "個人情報を入力してアカウントのセキュリティを向上させましょう。",
		verifyNow: "今すぐ認証",
		level2: "レベル2",
		kycVerification: "KYC認証",
		kycDesc: "KYC認証を完了すると、より高い限度額とすべての機能が利用できます。",
		docTip: "送信前に書類が鮮明で有効であることを確認してください。"
	},

	personalInfo: {
		verify: "認証",
		completeInfo: "情報を入力してください",
		completeInfoDesc: "個人情報を入力して認証を完了してください。",
		firstName: "名",
		paternalSurname: "父方の姓",
		maternalSurname: "母方の姓",
		contactNumber: "連絡先番号",
		phoneUsed: "この電話番号は既に使用されています。",
		contactEmail: "連絡先メール",
		invalidEmail: "メールアドレスが正しくありません。",
		detailedAddress: "詳細な住所",
		city: "市区町村",
		street: "番地",
		neighborhood: "地区",
		houseNumber: "建物番号",
		postalCode: "郵便番号",
		save: "保存",
		male: "男性",
		female: "女性"
	},

	withdrawPassword: {
		changeTitle: "出金パスワードの変更",
		setTitle: "出金パスワードの設定",
		changeDesc: "以前のパスワードを入力し、新しい出金パスワードを設定してください。",
		setDesc: "資金を保護するために出金パスワードを設定してください。",
		oldPlaceholder: "以前の出金パスワード",
		newPlaceholder: "新しい出金パスワード",
		confirmPlaceholder: "出金パスワードの確認"
	},

	contactBirthday: {
		title: "連絡先の誕生日",
		desc: "連絡を取りやすくするために誕生日を登録します。個人情報は保護されます。",
		label: "連絡先の誕生日",
		invalid: "無効な誕生日です。"
	},

	changePassword: {
		title: "パスワード変更",
		expiredDesc: "パスワードの有効期限が切れました。続行するには新しいパスワードを設定してください。",
		verifyOldDesc: "以前のパスワードを入力し、新しいパスワードを設定してください。",
		passwordPlaceholder: "以前のパスワード",
		newPlaceholder: "新しいパスワード",
		confirmPlaceholder: "新しいパスワードの確認",
		lengthError: "パスワードは6〜30文字で入力してください。",
		sameAsOld: "新しいパスワードは以前のものと同じにできません。",
		confirmRequired: "新しいパスワードを確認してください。",
		notMatch: "パスワードが一致しません。",
		success: "パスワードを変更しました",
		failed: "パスワードの変更に失敗しました"
	},

	settingsNav: {
		title: "設定",
		accountInfo: "アカウント情報",
		security: "セキュリティ"
	},
	verificationBirthday: {
		title: "生年月日",
		securityTip: "アカウントセキュリティのための生年月日です。ご本人様のみ連携できます。",
		clickSelectBirthday: "クリックして生年月日を選択",
		invalidBirthday: "無効な生年月日です",
		submitting: "送信中...",
		confirm: "確認",
		cancel: "キャンセル",
		selectBirthday: "生年月日を選択",
		birthdayRequired: "生年月日は必須です",
		updateBirthdayFail: "生年月日の更新に失敗しました",
		success: "更新に成功しました"
	}
};